import { useEffect } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import type { ParsedCommand } from '../../types/voice';

interface VoiceRecorderProps {
  onTranscript: (text: string) => void;
  onCommand?: (command: ParsedCommand) => void;
  isListening: boolean;
  onStartListening: () => void;
  onStopListening: () => void;
  showVisualizer?: boolean;
  language?: string;
}

export default function VoiceRecorder({
  onTranscript,
  isListening,
  onStartListening,
  onStopListening,
  showVisualizer = true,
  language = 'es-CO',
}: VoiceRecorderProps) {
  const {
    finalTranscript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
    isMicrophoneAvailable,
  } = useSpeechRecognition();

 

  
  // Handle final transcript (complete sentences)
  useEffect(() => {
    if (finalTranscript && finalTranscript.trim() !== '') {
     
      onTranscript(finalTranscript);
      // Try to parse as command from the accumulated transcript
      /*const command = parseCommand(accumulatedTranscriptRef.current);
      if (command.type !== 'text') {
        onCommand?.(command);
        // Reset accumulated transcript after command is processed
        accumulatedTranscriptRef.current = '';
      }*/
    }
  }, [finalTranscript]);
  
  

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (listening) {
        SpeechRecognition.stopListening();
      }
    };
  }, [listening]);

  const handleStart = () => {
    if (!browserSupportsSpeechRecognition) {
      console.error('Speech recognition not supported');
      return;
    }
    if (!isMicrophoneAvailable) {
      console.error('Microphone not available');
      return;
    }
    console.log("handel start")
    resetTranscript();
    onStartListening();
    SpeechRecognition.startListening({
        continuous: true,
        language,
      });
  };

  const handleStop = () => {
    onStopListening();
  };

  // Toggle listening
  useEffect(() => {
    if (isListening) {
      handleStart();
    } else {
      handleStop();
    }
  }, [isListening]);

  if (!browserSupportsSpeechRecognition) {
    return (
      <div className="text-error text-sm">
        Tu navegador no soporta reconocimiento de voz
      </div>
    );
  }

  if (!isMicrophoneAvailable) {
    return (
      <div className="text-warning text-sm">
        Micrófono no disponible
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      {showVisualizer && listening && (
        <div className="flex items-center gap-1">
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="w-1 bg-primary rounded-full animate-wave"
              style={{
                height: `${Math.random() * 20 + 10}px`,
                animationDelay: `${i * 100}ms`,
                animationDuration: `${500 + Math.random() * 300}ms`,
              }}
            />
          ))}
        </div>
      
      )}
      
      <div className={`w-3 h-3 rounded-full ${listening ? 'bg-error animate-pulse' : 'bg-base-300'}`} />
    </div>
  );
}